/**
 * antdv 基础款
 */

// import { default as Affix } from 'ant-design-vue/es/affix';

// import { default as Anchor } from 'ant-design-vue/es/anchor';

// import { default as AutoComplete } from 'ant-design-vue/es/auto-complete';

// import { default as Alert } from 'ant-design-vue/es/alert';

import { default as Avatar } from 'ant-design-vue/es/avatar';

import { default as BackTop } from 'ant-design-vue/es/back-top';

import { default as Badge } from 'ant-design-vue/es/badge';

import { default as Base } from 'ant-design-vue/es/base';

import { default as Breadcrumb } from 'ant-design-vue/es/breadcrumb';

import { default as Button } from 'ant-design-vue/es/button';

// import { default as Calendar } from 'ant-design-vue/es/calendar';

import { default as Card } from 'ant-design-vue/es/card';

import { default as Collapse } from 'ant-design-vue/es/collapse';

import { default as Carousel } from 'ant-design-vue/es/carousel';

// import { default as Cascader } from 'ant-design-vue/es/cascader';

import { default as Checkbox } from 'ant-design-vue/es/checkbox';

import { default as Col } from 'ant-design-vue/es/col';

// import { default as DatePicker } from 'ant-design-vue/es/date-picker';

import { default as Divider } from 'ant-design-vue/es/divider';

import { default as Dropdown } from 'ant-design-vue/es/dropdown';

// import { default as Form } from 'ant-design-vue/es/form';
import { default as FormModel } from 'ant-design-vue/es/form-model';

import { default as Icon } from 'ant-design-vue/es/icon';

import { default as Input } from 'ant-design-vue/es/input';

// import { default as InputNumber } from 'ant-design-vue/es/input-number';

import { default as Layout } from 'ant-design-vue/es/layout';

import { default as List } from 'ant-design-vue/es/list';

// import { default as LocaleProvider } from 'ant-design-vue/es/locale-provider';

import { default as message } from 'ant-design-vue/es/message';

import { default as Menu } from 'ant-design-vue/es/menu';

// import { default as Mentions } from 'ant-design-vue/es/mentions';

import { default as Modal } from 'ant-design-vue/es/modal';

import { default as notification } from 'ant-design-vue/es/notification';

import { default as Pagination } from 'ant-design-vue/es/pagination';

// import { default as Popconfirm } from 'ant-design-vue/es/popconfirm';

// import { default as Popover } from 'ant-design-vue/es/popover';

import { default as Progress } from 'ant-design-vue/es/progress';

import { default as Radio } from 'ant-design-vue/es/radio';

import { default as Rate } from 'ant-design-vue/es/rate';

import { default as Row } from 'ant-design-vue/es/row';

import { default as Select } from 'ant-design-vue/es/select';

// import { default as Slider } from 'ant-design-vue/es/slider';

import { default as Spin } from 'ant-design-vue/es/spin';

import { default as Statistic } from 'ant-design-vue/es/statistic';

// import { default as Steps } from 'ant-design-vue/es/steps';

import { default as Switch } from 'ant-design-vue/es/switch';

import { default as Table } from 'ant-design-vue/es/table';

// import { default as Transfer } from 'ant-design-vue/es/transfer';

// import { default as Tree } from 'ant-design-vue/es/tree';

// import { default as TreeSelect } from 'ant-design-vue/es/tree-select';

import { default as Tabs } from 'ant-design-vue/es/tabs';

import { default as Tag } from 'ant-design-vue/es/tag';

// import { default as TimePicker } from 'ant-design-vue/es/time-picker';

// import { default as Timeline } from 'ant-design-vue/es/timeline';

// import { default as Tooltip } from 'ant-design-vue/es/tooltip';

// import { default as Mention } from 'ant-design-vue/es/mention'

import { default as Upload } from 'ant-design-vue/es/upload';

import { default as version } from 'ant-design-vue/es/version';

import { default as Drawer } from 'ant-design-vue/es/drawer';

import { default as Skeleton } from 'ant-design-vue/es/skeleton';

// import { default as Comment } from 'ant-design-vue/es/comment';

// import { default as ColorPicker } from 'ant-design-vue/es/color-picker';

// import { default as ConfigProvider } from 'ant-design-vue/es/config-provider';

import { default as Empty } from 'ant-design-vue/es/empty';

import { default as Result } from 'ant-design-vue/es/result';

import { default as Descriptions } from 'ant-design-vue/es/descriptions';

import { default as PageHeader } from 'ant-design-vue/es/page-header';

import { default as Space } from 'ant-design-vue/es/space';
 
const components = [
    Base,
    // Affix,
    // Anchor,
    // AutoComplete,
    // Alert,
    Avatar, BackTop, Badge,
    // Breadcrumb,
    Button,
    // Calendar,
    Card,
    Collapse,
    Carousel,
    // Cascader,
    Checkbox, Col,
    // DatePicker,
    Divider,
    Dropdown,
    // Form,
    FormModel, Icon, Input,
    // InputNumber,
    Layout, List,
    // LocaleProvider,
    Menu,
    // Mentions,
    Modal, Pagination,
    // Popconfirm,
    // Popover,
    Progress, Radio, Rate, Row, Select,
    // Slider,
    Spin, Statistic,
    // Steps,
    Switch, Table,
    // Transfer,
    // Tree,
    // TreeSelect,
    Tabs, Tag,
    // TimePicker,
    // Timeline,
    // Tooltip,
    Upload, Drawer, Skeleton,
    // Comment,
    // ColorPicker,
    // ConfigProvider,
    Empty, Result, Descriptions, PageHeader, Space
];

const install = function install(Vue) {
    components.map(function (component) {
        Vue.use(component);
    });

    Vue.prototype.$message = message;
    Vue.prototype.$notification = notification;
    Vue.prototype.$info = Modal.info;
    Vue.prototype.$success = Modal.success;
    Vue.prototype.$error = Modal.error;
    Vue.prototype.$warning = Modal.warning;
    Vue.prototype.$confirm = Modal.confirm;
    Vue.prototype.$destroyAll = Modal.destroyAll;
};
 
/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
   install(window.Vue);
}
 
export default {
   version: version,
   install: install
};